/** Канон героини: портрет и лист образа (или пунктир «нет канона») и кнопки запуска листа/пересборки. */
import clsx from "clsx";

import { Btn, Hint, Panel } from "@/components/project/ui";
import { RetryImg } from "@/components/trends/PinGrid";
import { mediaUrl } from "@/lib/media";
import type { PersonaView } from "@/lib/persona";

function Slot({ path, ratio, empty }: { path: string | null; ratio: string; empty: string }) {
  return (
    <div
      className={clsx(
        "relative overflow-hidden rounded-[var(--radius-ui)]",
        ratio,
        path ? "border border-border bg-bg" : "grid place-items-center border border-dashed border-border-strong",
      )}
    >
      {path ? (
        <RetryImg src={mediaUrl(path)} alt="" className="absolute inset-0 h-full w-full object-cover" />
      ) : (
        <span className="px-2 text-center text-[12px] text-fg-faint">{empty}</span>
      )}
    </div>
  );
}

export function CanonBlock({
  view,
  onSheet,
  onRebuild,
}: {
  view: PersonaView;
  onSheet: () => void;
  onRebuild: () => void;
}) {
  const { portrait, sheet } = view.canon;
  return (
    <Panel title="Канон" aside="эталон героини для следующих генераций и будущей примерки" annot="канон героини">
      <div className="grid items-start gap-3 sm:grid-cols-[minmax(0,200px)_minmax(0,300px)_1fr]">
        <Slot path={portrait?.asset_path ?? null} ratio="aspect-[3/4]" empty="нет канона" />
        <Slot path={sheet?.asset_path ?? null} ratio="aspect-[3/2]" empty="нет листа" />
        <div className="grid gap-2">
          <Btn onClick={onSheet} disabled={!portrait}>
            Лист персонажа
          </Btn>
          <Btn onClick={onRebuild} disabled={!portrait}>
            Пересобрать из канона
          </Btn>
          <Hint>
            {portrait
              ? "Лист и пересборка идут от канонического портрета."
              : "Откройте лучшую картинку в ленте → «Сделать каноном»."}
          </Hint>
        </div>
      </div>
    </Panel>
  );
}
